export default __webpack_public_path__ + "static/media/6.0f222f11.jpg";